import { useState, useEffect } from "react";
import interact from "interactjs";

export default function Draggable({ isOpen, dragHandle }) {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isOpen) return;

    setPosition({ x: 0, y: 0 });

    interact(dragHandle).draggable({
      listeners: {
        move(event) {
          setPosition((prev) => ({
            x: prev.x + event.dx,
            y: prev.y + event.dy
          }));
        },
      },
      inertia: false, 
    });

    return () => {
      interact(dragHandle).unset();
    };
  }, [isOpen, dragHandle]);

  return position;
}
